// extracted by mini-css-extract-plugin
module.exports = {"errorBanner":"EmailVerificationBanner_errorBanner__OwBzL","linkButton":"EmailVerificationBanner_linkButton__h9TTc","successBanner":"EmailVerificationBanner_successBanner__241Pm"};